import './assets/css/main.css'
import './components/molecules/phone-input/scss/country-flags.scss'
import 'gridstack/dist/gridstack.min.css'

import { createApp } from 'vue'

import { Ripple, ToastService, Tooltip } from 'primevue'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'

import { createPinia } from 'pinia'

import { instanceI18n } from '@/plugins/i18n'

import { createHead } from '@unhead/vue/client'

import App from './App.vue'
import router from './router'
import { AppTheme } from './theme/app-theme'
import { useDarkMode } from './composables/useDarkMode'

const pinia = createPinia()
const app = createApp(App)
const head = createHead()

app.use(head)

app.use(PrimeVue, {
  theme: {
    preset: AppTheme,
    options: {
      prefix: 'p',
      darkModeSelector: '.dark',
    },
  },
  locale: {
    firstDayOfWeek: 1,
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    today: 'Hoy',
    clear: 'Limpiar',
    weekHeader: 'Sm',
  },
})

app.use(ToastService)

app.use(pinia)

app.use(router)

app.use(instanceI18n)

app.directive('tooltip', Tooltip)
app.directive('ripple', Ripple)
app.use(ConfirmationService)

useDarkMode()

app.mount('#app')
